import React from 'react';
import injectSheet from 'react-jss';

import Typography from '@material-ui/core/Typography';

const NothingToAdd = ({ classes }) => (
    <div className={classes.wrapper}>
        <div className={classes.iconWrapper}>
            <i className={classes.icon}>group_add</i>
        </div>
        <Typography variant="title" className={classes.text}>
            No members to add
        </Typography>
        <Typography variant="subheading" className={classes.description}>
            Add members to organization first in order to see them here.
        </Typography>
    </div>
);

const style = ({ palette, spacing, avatar }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: spacing.unit * 2,
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        background: avatar.extraLarge.background,
        width: avatar.extraLarge.width,
        height: avatar.extraLarge.height,
        marginTop: spacing.unit * 6,
    },
    icon: {
        color: palette.text.secondary,
        fontSize: 48,
        composes: ['material-icons'],
    },
    text: {
        marginTop: spacing.unit * 4,
    },
    description: {
        color: palette.text.secondary,
        marginTop: spacing.unit * 2,
        textAlign: 'center',
    },
});

export default injectSheet(style)(NothingToAdd);



// WEBPACK FOOTER //
// ./src/components/NothingToAdd.js